export enum PlaceholderType {
  Resource = 'Resource',
  Element = 'Element',
}
